import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import featherShare from "../../../assets/images/Icon-feather-share.png";
import featherTrash from "../../../assets/images/Icon-feather-trash-2.png";
import downloadDark from "../../../assets/images/downloadDark.png";
import PlusIMgDark from "../../../assets/images/plusDark.png";
import noRecord from "../../../assets/images/cloud-cross.png";
import { delSheetSettings } from "../../../redux/actions/sheetSettings";
// import { sheetTemplateUrl } from '../config/index.js';
import copyDarkImg from '../../../assets/images/copyDark.png';
import { sheetTemplateUrl } from "../../../config";

const SheetList = ({
  allSheets,
  setOpenSheetModal,
  sampleCSVdownload,
  type,
}) => {
  const disptach = useDispatch();
  return (
    <div id="tab-1" className="tab-content  current">
      <div className="webhookTabContent fullHeight">
        <div className="tabTableBody">
          {allSheets && allSheets.length > 0 && (
            <div className="eachTableRow heading">
              <div className="tableCells">Id</div>
              <div className="tableCells">Title</div>
              <div className="tableCells">Open</div>
              <div className="tableCells">Delete</div>
            </div>
          )}
          {allSheets && allSheets.length
            ? allSheets.map((sheet, i) => {
                return (
                  <div className="eachTableRow" key={i}>
                    <div className="tableCells ">{sheet.spreadsheetId}</div>
                    <div className="tableCells ">{sheet.spreadsheetTitle}</div>
                    <div className="tableCells actionImgs">
                      <a
                        href={`https://docs.google.com/spreadsheets/d/${sheet.spreadsheetId}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={featherShare}
                          className="actionBtnImgs"
                          alt=""
                        />
                      </a>
                    </div>
                    <div className="tableCells actionImgs">
                      <Link
                        to="/ss#"
                        onClick={(e) => {
                          e.preventDefault();
                          disptach(delSheetSettings(sheet._id, sheet.type));
                        }}
                      >
                        <img
                          src={featherTrash}
                          className="actionBtnImgs"
                          alt=""
                        />
                      </Link>
                    </div>
                  </div>
                );
              })
            : ""}
        </div>
        {allSheets && allSheets.length < 1 && (
          // <div className='noRecordTables'>No Records Found</div>
          <ul className="individualRow noRecordsWraper tableContent">
            <li className="noRecord messageWrater">
              <p>No Records found</p>
              <span className="noImageWraper">
                <img src={noRecord} alt="" />
              </span>
              <span className="noRecorsBtnWraper">
                <button
                  style={{ margin: "10px 0 0 0" }}
                  className="firstBtn gmNewBtn tabBtns"
                  onClick={() => setOpenSheetModal(true)}
                >
                  <img src={PlusIMgDark} className="tabBtnImgs" alt="" /> Add
                  Sheet
                </button>
                {type === "data" && (
                  <button
                    className="secondBtn gmNewBtn tabBtns"
                    onClick={() => sampleCSVdownload()}
                  >
                    <img src={downloadDark} className="tabBtnImgs" alt="" />{" "}
                    Download Sample CSV
                  </button>
                )}
                {type === "preApproved" && (
                  <button
                    className="secondBtn gmNewBtn tabBtns"
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(sheetTemplateUrl, "_blank");
                    }}
                  >
                    <img src={copyDarkImg} className="tabBtnImgs" alt="" /> Copy
                    Template
                  </button>
                )}
              </span>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default SheetList;
